import React, { Fragment, useEffect, useRef, useState } from 'react';
import { translate } from '../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import Notification from './Notification';
import {
    getAllWishlists,
    updateWishlistName,
    add,
    addAll,
    setActiveWishlist,
    showWishlistDrawer,
    setIsInWishlist,
    setIncludedInWishlists,
    getWishlist,
} from '../Actions/Wishlist.action';

const WishListAdd = ({ articleNumber, onClose, addCart = false }) => {
    const [editWishlistCurrentName, setEditWishlistCurrentName] = useState('');
    const [editWishlistNewName, setEditWishlistNewName] = useState('');
    const [wishlistName, setWishlistName] = useState('');
    const [showCreateWishlist, setShowCreateWishlist] = useState(false);
    const [edit, setEdit] = useState(false);
    const wishlist = useSelector((state) => state.wishlist);
    const { payload } = wishlist;
    const ref = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllWishlists());
    }, [dispatch]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onClose();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, onClose]);

    function handleEdit(listName) {
        setEdit(true);
        setEditWishlistCurrentName(listName);
        setEditWishlistNewName(listName);
    }

    function addWishlistName(evt) {
        const val = evt.target.value;
        setWishlistName(val);
    }

    function updateEditWishlist(evt) {
        const val = evt.target.value;
        setEditWishlistNewName(val);
    }

    function openWishlistDrawer(listName) {
        dispatch(setActiveWishlist(listName));
        dispatch(getWishlist(listName));
        dispatch(showWishlistDrawer(true));
    }

    async function handleAddToWishlist(listName, articleNumber) {
        await dispatch(add(listName, articleNumber));
        await dispatch(getAllWishlists());
        dispatch(setIsInWishlist(true, listName));
        if (wishlist?.includedInWishlists) {
            dispatch(
                setIncludedInWishlists([
                    ...wishlist.includedInWishlists,
                    listName,
                ])
            );
        } else {
            dispatch(setIncludedInWishlists([listName]));
        }
        openWishlistDrawer(listName);
        onClose();
    }

    function handleAddCartItemsToWishlist(listName) {
        dispatch(addAll(listName));
        dispatch(getAllWishlists());
        onClose();
    }

    async function handleAddWishlist(listName, articleNumber) {
        await dispatch(add(listName, articleNumber));
        await dispatch(getAllWishlists());
        dispatch(getWishlist(listName));
        dispatch(setIsInWishlist(true));
        dispatch(
            setIncludedInWishlists([...wishlist.includedInWishlists, listName])
        );
        setShowCreateWishlist(false);
        openWishlistDrawer(listName);
        onClose();
    }

    async function handleUpdateWishlistName() {
        dispatch(
            updateWishlistName(editWishlistCurrentName, editWishlistNewName)
        ).then(() => dispatch(getAllWishlists()));
    }

    async function handleAddWishlistFromCart(listName) {
        await handleAddCartItemsToWishlist(listName).then(() => {
            dispatch(getAllWishlists());
        });
        setShowCreateWishlist(false);
        openWishlistDrawer(listName);
        onClose();
    }

    return (
        <Fragment>
            <div className="wishlist-add__container">
                <div
                    className={`wishlist-add__info ${
                        addCart ? 'wishlist-add__info--cart' : ''
                    }`}
                >
                    <div className="wishlist-add__content" ref={ref}>
                        <div className="wishlist-add__close-button-wrapper">
                            <span
                                className="wishlist-add__close-button"
                                onClick={() => onClose()}
                            ></span>
                        </div>
                        <div className="wishlist-add__top-content">
                            <p className="wishlist-add__top-title">
                                {edit
                                    ? translate('wishlist.add.edit.title')
                                    : translate('wishlist.add.create.title')}
                            </p>
                            {!showCreateWishlist && (
                                <button
                                    type="submit"
                                    className="button wishlist-add__new-list-button"
                                    onClick={() => {
                                        setShowCreateWishlist(true),
                                            setEdit(false);
                                    }}
                                >
                                    {translate('wishlist.add.addnew')}
                                </button>
                            )}
                        </div>

                        {payload && payload.success == false && (
                            <Notification text={payload.message} />
                        )}

                        {showCreateWishlist && (
                            <div className="wishlist-edit__container">
                                <input
                                    className="form__input"
                                    id="wishlist-name"
                                    name="name"
                                    type="text"
                                    placeholder={translate(
                                        'wishlist.add.inputplaceholder'
                                    )}
                                    value={wishlistName}
                                    onChange={(evt) => addWishlistName(evt)}
                                />
                                <div className="wishlist-edit__button-wrapper">
                                    <button
                                        type="submit"
                                        className="button button--cancel"
                                        onClick={() =>
                                            setShowCreateWishlist(false)
                                        }
                                    >
                                        {translate('wishlist.cancel')}
                                    </button>
                                    <button
                                        type="submit"
                                        className="button button--submit"
                                        onClick={async () => {
                                            if (addCart) {
                                                await handleAddWishlistFromCart(
                                                    wishlistName
                                                );
                                            } else {
                                                await handleAddWishlist(
                                                    wishlistName,
                                                    articleNumber
                                                );
                                            }
                                        }}
                                    >
                                        {translate('wishlist.save')}
                                    </button>
                                </div>
                            </div>
                        )}

                        {edit && (
                            <div className="wishlist-edit__container">
                                <input
                                    className="form__input"
                                    id="wishlist-name"
                                    name="name"
                                    type="text"
                                    value={editWishlistNewName}
                                    onChange={(evt) => updateEditWishlist(evt)}
                                />
                                <div className="wishlist-edit__button-wrapper">
                                    <button
                                        type="submit"
                                        className="button button--cancel"
                                        onClick={() => setEdit(false)}
                                    >
                                        {translate('wishlist.cancel')}
                                    </button>
                                    <button
                                        type="submit"
                                        className="button button--submit"
                                        onClick={() => {
                                            handleUpdateWishlistName();
                                            setEdit(false);
                                        }}
                                    >
                                        {translate('wishlist.save')}
                                    </button>
                                </div>
                            </div>
                        )}
                        {wishlist && !showCreateWishlist && !edit && (
                            <div
                                className={`wishlist-lists__container ${
                                    addCart
                                        ? 'wishlist-lists__container--cart'
                                        : ''
                                }`}
                            >
                                {wishlist.lists &&
                                    Object.values(wishlist.lists).map(
                                        (list, index) => (
                                            <div
                                                key={`wishlist-list-item-${index}`}
                                                className="wishlist-lists__item"
                                            >
                                                <p
                                                    className="wishlist-lists__text"
                                                    onClick={() =>
                                                        addCart
                                                            ? handleAddCartItemsToWishlist(
                                                                  list.name
                                                              ).then(() =>
                                                                  openWishlistDrawer(
                                                                      list.name
                                                                  )
                                                              )
                                                            : handleAddToWishlist(
                                                                  list.name,
                                                                  articleNumber
                                                              )
                                                    }
                                                >
                                                    {list.name}
                                                </p>
                                                <button
                                                    className="wishlist-lists__edit-button"
                                                    onClick={() => {
                                                        handleEdit(list.name);
                                                    }}
                                                    title={translate(
                                                        'wishlist.add.edit'
                                                    )}
                                                ></button>
                                            </div>
                                        )
                                    )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default WishListAdd;
